<div class="title-search-bar">
  <form autocomplete="off">
    <div class="input-group search-group mb-0" [ngClass]="isOpen ? 'open' : ''">
      <div class="input-group-prepend">
        <a (click)="open()"><img src="assets/icons/search.svg" class="search-icon" /></a>
      </div>
      <input
        id="search-input"
        #searchInput
        type="text"
        class="form-control"
        autocomplete="off"
        [ngClass]="{ open: isOpen, 'narrow-search': getSearchType() != 'Clients' }"
        placeholder="{{
          getSearchType() == 'Clients' ? 'Search for client ID, legal or DBA Name' : 'Search People'
        }}"
        (keyup)="search($event)"
        (blur)="showResults()"
        (focus)="showResults()" />
      <div *ngIf="showSearchResults && hasSearched" id="results-list" class="card">
        <div class="card-body">
          <small>
            <em *ngIf="!items || items.length === 0">No results found</em>
          </small>
          <!-- if theres no client code, we are searching clients -->
          <table *ngIf="items && items.length > 0 && !clientCode" class="table cell-wrap">
            <tbody>
              <tr *ngFor="let item of items.slice(0, maxResultSet)">
                <td>
                  <a (click)="navigateToClient(item.Id)"
                    ><strong>{{ item.Id }}</strong></a
                  >
                </td>
                <td>
                  <a (click)="navigateToClient(item.Id)">{{ item.DBA }}</a>
                </td>
                <td>
                  <a (click)="navigateToClient(item.Id)">{{ item.Name }}</a>
                </td>
              </tr>
            </tbody>
          </table>
          <ul *ngIf="items && clientCode">
            <li *ngFor="let item of items.slice(0, maxResultSet)">
              <a (click)="navigateToPerson(item.Id)">
                <strong>{{ displayPerson(item) }} </strong>
              </a>
            </li>
          </ul>
          <div *ngIf="items && items.length > maxResultSet">
            <br />
            <a
              *ngIf="clientCode"
              routerLink="/client/{{ clientCode }}/people/search/{{ searchQuery }}"
              class="text-muted"
              >View All Results</a
            >
            <a *ngIf="!clientCode" routerLink="/clients/search/{{ searchQuery }}"
              >View All Results</a
            >
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
